import { Container, Grid, Paper, Typography, Box } from '@mui/material';
import { ChatInterface } from '../../../templates/OciAiTest/ChatInterface';
import { ModelSelector } from '../../../templates/OciAiTest/ModelSelector';
import { AdvancedOptions } from '../../../templates/OciAiTest/AdvancedOptions';
import { useChatPage } from './useChatPage';

/**
 * OCI AI 테스트 - 채팅 페이지
 * 
 * @description AI 모델과 1:1 채팅을 수행하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-20
 */
const OciAiTestChatPage = () => {
  const {
    selectedModel,
    setSelectedModel,
    messages,
    setMessages,
    isLoading,
    advancedOptions,
    setAdvancedOptions,
    availableModels,
    sendMessage,
  } = useChatPage();

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box mb={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          🤖 AI 모델 채팅 테스트
        </Typography>
        <Typography variant="body1" color="text.secondary">
          다양한 OCI GenAI 모델과 실시간 채팅을 통해 성능을 테스트해보세요.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* 좌측 패널 - 모델 선택 및 설정 */}
        <Grid item xs={12} md={4} lg={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>
                  모델 선택
                </Typography>
                <ModelSelector
                  selectedModel={selectedModel}
                  onModelChange={setSelectedModel}
                  models={availableModels}
                />
              </Paper>
            </Grid>
            
            <Grid item xs={12}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>
                  고급 옵션
                </Typography>
                <AdvancedOptions
                  options={advancedOptions}
                  onChange={setAdvancedOptions}
                />
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        {/* 우측 패널 - 채팅 인터페이스 */}
        <Grid item xs={12} md={8} lg={9}>
          <Paper sx={{ p: 2, height: 'calc(100vh - 200px)' }}>
            <ChatInterface
              messages={messages}
              onMessagesChange={setMessages}
              onSendMessage={sendMessage}
              isLoading={isLoading}
              currentModel={selectedModel}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default OciAiTestChatPage;